import { IsEnum, IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator';

export enum ParkSafePageSlug {
  PLEDGE = 'pledge',
  FAQ = 'faq',
}

export class UpsertParkSafePageRequestDTO {
  @IsEnum(ParkSafePageSlug)
  slug!: ParkSafePageSlug;

  @IsString()
  @IsNotEmpty()
  text!: string;

  @IsString()
  @IsNotEmpty()
  title!: string;

  @IsString()
  @IsNotEmpty()
  @IsOptional()
  imageKey?: string;
}

export class ParkSafePageResponseDTO {
  @IsEnum(ParkSafePageSlug)
  slug!: ParkSafePageSlug;

  @IsString()
  @IsNotEmpty()
  title!: string;

  @IsString()
  @IsNotEmpty()
  text!: string;

  @IsString()
  imageKey!: string | null;

  @IsString()
  imageUrl!: string | null;
}
